import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MyOrder } from '../../../MyOrder';

/**
 * Customer dashboard Orders page - wraps the existing MyOrder component
 * so all order actions (view, cancel, return, invoice) work the same.
 */
const Orders = () => {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/customer/dashboard')}
          className="text-gray-600 hover:text-gray-900 text-sm font-medium"
        >
          ← Dashboard
        </button>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <MyOrder embedded />
      </div>
    </div>
  );
};

export default Orders;
